
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".506","y":".895","width":"7.938","height":"15.67","rx":"1","fill":"#007EC1"}}),_c('rect',{attrs:{"x":"9.655","y":".895","width":"7.938","height":"5.037","rx":"1","fill":"#0067AD"}}),_c('rect',{attrs:{"x":"9.655","y":"7.131","width":"7.938","height":"9.434","rx":"1","fill":"#00A2AD"}})])
          )
        }
      }
    